// extracted by mini-css-extract-plugin
module.exports = {"productDescriptionBody":"HowToUseAccordion_productDescriptionBody__Mmc8U"};